import { useEffect, useState } from "react";
import { Link, Route, Routes, useLocation } from "react-router-dom";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
} from "@/components/ui/sidebar";
import { Mail, MessageSquare, Users, FileIcon } from "lucide-react";
import Email from "./Email.tsx";
import Messaging from "./Messaging.tsx";
import Directory from "./Directory.tsx";
import { Files } from "./Files.tsx";

// Menu items.
const items = [
  {
    title: "Messaging",
    url: "/sources/messaging",
    icon: MessageSquare,
  },
  {
    title: "Email",
    url: "/sources/email",
    icon: Mail,
  },
  {
    title: "Contacts",
    url: "/sources/directory",
    icon: Users,
  },
  {
    title: "Files",
    url: "/sources/files",
    icon: FileIcon,
  },
];

function Sources() {
  const location = useLocation();
  const [selection, setSelection] = useState<number>(0);

  useEffect(() => {
    let defaultIndex = items.findIndex((item) => {
      return location.pathname.startsWith(item.url);
    });

    if (defaultIndex < 0) {
      defaultIndex = 1;
    }

    setSelection(defaultIndex);
  }, []);

  return (
    <div className="flex w-full h-full">
      <Sidebar
        collapsible="none"
        className="hidden flex-1 lg:flex w-[324px] md:left-12 pl-8 pr-8 pt-2 top-0 bottom-0 min-w-[324px] flex-grow-0 gap-8 fixed"
      >
        <SidebarHeader className="gap-3.5 p-4 pt-16">
          <div className="text-base text-foreground">
            <h2 className="scroll-m-20 pb-6 text-3xl font-semibold tracking-tight transition-colors first:mt-0 text-accent-foreground">
              Database
            </h2>
            <p className="text-xl text-muted-foreground">Field Agent is using data from these sources</p>
          </div>
        </SidebarHeader>
        <SidebarContent>
          <SidebarGroup>
            <SidebarGroupContent>
              <SidebarMenu>
                {items.map((item, i) => (
                  <SidebarMenuItem key={item.title}>
                    <SidebarMenuButton asChild isActive={i === selection} onClick={() => setSelection(i)}>
                      <Link to={item.url}>
                        <item.icon strokeWidth={2.3} size={48} />
                        <span>{item.title}</span>
                      </Link>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                ))}
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>
        </SidebarContent>
      </Sidebar>
      {/* container for source interface */}
      <div className="flex w-full justify-center bg-background fixed top-0 bottom-0 right-0 md:left-16 lg:left-[372px] pl-8">
        <Routes>
          <Route path="messaging/:messageId?" element={<Messaging />} />
          <Route path="email/:emailId?" element={<Email />} />
          <Route path="directory" element={<Directory />} />
          <Route path="files/:fileId?" element={<Files />} />
          <Route path="" element={<Email />} />
        </Routes>
      </div>
    </div>
  );
}

export default Sources;
